export default __webpack_public_path__ + "static/media/facebook.97fd39fa.svg";